export default {
  created() {
    this.pageComponent.children = this.pageComponent.children.sort((a, b) => a.order - b.order);
    this.pageComponent.parent_elements = this.pageComponent.parent_elements.sort((a, b) => a.order - b.order);
  },
};
